import { render, staticRenderFns } from "./Related.vue?vue&type=template&id=4ec8ef00&scoped=true&"
import script from "./Related.vue?vue&type=script&lang=ts&"
export * from "./Related.vue?vue&type=script&lang=ts&"
import style0 from "./Related.vue?vue&type=style&index=0&id=4ec8ef00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec8ef00",
  null
  
)

export default component.exports